An array of identifiers for the `HiringOrganization`s that have the position.

A maximum of 1 organization may be provided.

Information such as the organization's domicile may be used to refine the returned suggestions.
